// import something here
import _ from 'lodash';
import utils from '../others/utils.js';

// leave the export, even if you don't use it
export default ({ Vue }) => {
  Vue.filter('errorLabel', (val) => {
    let msg = '';
    if (val) {
      _.forOwn(val.$params, (value, key) => {
        if (!val[key]) {
          msg = value.message;
          return false;
        }
      });
    }
    return msg;
  });

  Vue.filter('formatDate', (value) => {
    if (!value) return '';
    return value.toLocaleDateString('ru');
  });

  Vue.filter('formatTime', (value) => {
    if (!value) return '';
    if (typeof value === 'number') {
      value = new Date(value);
    }
    try {
      return value.toLocaleString('ru').slice(0, -3);
    } catch (e) {
      return value;
    }
  });

  Vue.filter('formatSize', value => utils.formatSize(value));
};



// WEBPACK FOOTER //
// ./src/plugins/filters.js